import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";


export default function Login({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();


  const handleLogin = async () => {
    try {
      const res = await axios.post("/api/auth/login", { username, password });
      const { token, role } = res.data;

      // Salvar token e role
      localStorage.setItem("token", token);
      localStorage.setItem("role", role);
      onLogin(role, token);

      // redirecionar conforme o role
      if (role === "admin") {
        navigate("/admin", { replace: true });
      } else if (role === "tech") {
        navigate("/mapa", { replace: true });
      } else if (role === "viewer") {           // ← NOVO
        navigate("/admin", { replace: true });
      } else {
        // fallback
        navigate("/login", { replace: true });
      }

    } catch (err) {
      alert(err.response?.data?.error || "Erro ao logar");
    }
  };

  return (
    <div style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
      background: "#f0f0f0"
    }}>
      <div style={{
        background: "#fff",
        padding: "40px",
        borderRadius: "8px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
        display: "flex",
        flexDirection: "column",
        gap: "15px",
        minWidth: "300px",
        textAlign: "center"
      }}>
        <div style={{ marginBottom: "1px" }}>
          <img
            src="/iclickmap512.png"   
            alt="IClickMap Logo"
            style={{ width: "100px", marginBottom: "1px" }}
          />
        </div>
        {/*<h2 style={{ textAlign: "center" }}>Login</h2>*/}
        <input className="form-control" placeholder="Usuário" value={username} onChange={e => setUsername(e.target.value)} />
        <input className="form-control" type="password" placeholder="Senha" value={password} onChange={e => setPassword(e.target.value)} />
        <button className="btn btn-success" onClick={handleLogin} style={{ padding: "10px" }}>Entrar</button>
      </div>
    </div>
  );
}
